import { useVaultDisplayName } from "../../hooks/useVaultDisplayName";
import { useGcStats } from "../../hooks/useGcStats";
import { useSession } from "../../stores/session";
import { useMasterSession } from "../../stores/masterSession";
import type { VaultEntry } from "../../worker/api";

function adapterConfigLabel(v: VaultEntry | undefined): string {
  if (!v) return "—";
  if (v.adapter.type === "opfs") return `opfs://local/${v.adapter.subdir}`;
  return `${v.adapter.endpoint}/${v.adapter.bucket}${v.adapter.prefix ? `/${v.adapter.prefix}` : ""}`;
}

export function VaultDetailsTab() {
  const session = useSession((s) => s.session);
  const displayName = useVaultDisplayName().data ?? "";
  const stats = useGcStats().data;
  const vaultEntry = useMasterSession((s) =>
    s.master?.appConfig?.vaults.find((v) => v.id === session?.vaultId),
  );

  return (
    <div className="max-w-xl space-y-4">
      <h2 className="text-xl font-medium">Vault details</h2>
      <Row label="Display name" value={displayName} />
      <Row label="Adapter" value={vaultEntry?.adapter.type ?? "—"} />
      <Row label="Adapter config" value={adapterConfigLabel(vaultEntry)} mono />
      <Row
        label="Files"
        value={stats ? stats.files.toLocaleString() : "—"}
        mono
      />
      <Row
        label="Total size"
        value={stats ? `${(stats.bytes / (1 << 30)).toFixed(2)} GB` : "—"}
        mono
      />
    </div>
  );
}

function Row({
  label,
  value,
  mono,
}: {
  label: string;
  value: string;
  mono?: boolean;
}) {
  return (
    <div className="flex justify-between border-t border-border py-3 text-sm">
      <span className="text-text-soft">{label}</span>
      <span className={mono ? "font-mono text-[12px]" : undefined}>{value}</span>
    </div>
  );
}
